// core
import {Component} from "@angular/core";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {CustomerModel} from "app/customer/models/customer-model";

import {TranslateService} from "@ngx-translate/core";
// constants
import {AppConstants} from "app/utils/constants";

// services
import {UtilsService} from "app/utils/utils.service";
import {CustomerService} from "app/customer/services/customer-service.service";
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

declare var $: any;

@Component({
    selector: 'customer-by-customer-number-modal',
    templateUrl: './customer-by-customer-number-modal.component.html',
    styleUrls: ['./customer-by-customer-number-modal.component.scss'],
    standalone: false
})
export class CustomerByCustomerNumberModal {

  // input values
  public currentFlow: string;
  public callBack;
  private data;
  private targetGroupForSendingBack;

  public customerForm: UntypedFormGroup;
  private addUserFlow: string = AppConstants.CREATE_MODE;
  private editUserFlow: string = AppConstants.EDIT_MODE;
  private currentCustomer: CustomerModel;
  private validCustomerNumber: boolean = true;

  public loading = false;
  public error_message: string;

  constructor(
    public customerByCustomerNumberModalRef: BsModalRef,
    private _utilsService: UtilsService,
    private _formBuilder: UntypedFormBuilder,
    private _modalService: BsModalService,
    private _customerService: CustomerService,
    private _translateService: TranslateService
  ) {
    // output values
    this.customerForm = this._formBuilder.group({
      customerNumber: [
        {
          value: '',
          disabled: false
        },
        Validators.compose([
          Validators.required,
          Validators.pattern(this._utilsService.getOnlyNumbersRegex()),
          Validators.maxLength(10)
        ])
      ],
      company: [
        {
          value: '',
          disabled: true
        },
        Validators.required
      ],
      targetGroup: [
        {
          value: '',
          disabled: true
        },
        Validators.required
      ],
      contactPerson: [
        {
          value: '',
          disabled: true
        },
        Validators.required
      ]
    });
  }

  ngOnInit() {
    this._subscribeToCustNrChange();
  }

  public getAddUserFlow() {
    return this.addUserFlow;
  }

  public getEditUserFlow() {
    return this.editUserFlow;
  }

  public getCurrentCustomer() {
    return this.currentCustomer;
  }

  public getValidCustomerNumber() {
    return this.validCustomerNumber;
  }

  public getErrorMessage() {
    return this.error_message;
  }

  public goToNextStep() {
    this.customerByCustomerNumberModalRef.hide();
    this.data = {
      company: this.customerForm.controls['company'].value,
      customerNumber: this.customerForm.controls['customerNumber'].value,
      targetGroup: this.targetGroupForSendingBack,
      contactPerson: this.customerForm.controls['contactPerson'].value,
    };
    this.callBack(AppConstants.customerByCustomerNumberModal, this.data);
  }

  private _subscribeToCustNrChange() {
    this.customerForm.controls['customerNumber'].valueChanges
      .subscribe(term => {
        this.currentCustomer = null;
        if (this.customerForm.controls['customerNumber'].invalid) {
          this.validCustomerNumber = true;
        }
      });

    this.customerForm.controls['customerNumber'].valueChanges.pipe(
      debounceTime(1200),
      distinctUntilChanged()
    )
    .subscribe(term => {
      if (this.customerForm.controls['customerNumber'].valid) {
        this._onCustNrChange(term);
      }
    },
    (error) => {});

  }

  private _onCustNrChange(term: string) {
    if (term) {
      this.loading = true;
      this._customerService.getCustomerByCustomerNumberWithValidation(term).subscribe(
      //this._customerService.getCustomerByCustomerNumber(term).subscribe(
        data => {
          this.loading = false;
          this.currentCustomer = data;
          this.validCustomerNumber = true;
          this._fillCustomer(this.currentCustomer);
          $('#toastrContainer').removeClass('d-none');
        }, (error) => {

          this.error_message = error.message;
          this.loading = false;
          this.validCustomerNumber = false;
          this._emptyCustomerFields(true);
          $('#toastrContainer').addClass('d-none');
        }
      );
    }
  }

  private _fillCustomer(customerData: CustomerModel) {
    if (customerData) {
      this.targetGroupForSendingBack = customerData.customerCategory;
      this.customerForm.controls['company'].setValue(customerData.customerName);
      this.customerForm.controls['targetGroup'].setValue(this._getTargetGroupTranslation(customerData.customerCategory));
      this.customerForm.controls['contactPerson'].setValue(this._utilsService.concatFirstNameWithLastName(customerData.contactPersonFirstName, customerData.contactPersonLastName));
    }
  }

  private _getTargetGroupTranslation(targetGroup) {
    let translation;
    this._translateService.get(targetGroup).subscribe(translate => translation = translate);
    return translation;
  }

  private _emptyCustomerFields(emptyRoles: boolean) {
    this.customerForm.controls['company'].setValue(null);
    this.customerForm.controls['targetGroup'].setValue(null);
    this.customerForm.controls['contactPerson'].setValue(null);
  }
}
